import { call, put, takeLatest } from "redux-saga/effects";

import {
  getAccountTransactionsSuccess,
  getAccountTransactionsFailure,
} from "./AccountTransactions.actions";
import { AccountTransactionsService } from "./AccountTransactions.store";

function* getAccountTransactionsSaga(args) {
  try {
    const accountTransactionsService = new AccountTransactionsService();
    const { data, total } = yield call(
      accountTransactionsService.fetchAccountTransactions,
      args
    );
    const { token, dateRange } = args;
    yield put(getAccountTransactionsSuccess(data, token, dateRange, total));
  } catch (error) {
    yield put(getAccountTransactionsFailure(error));
  }
}

export function* accountTransactionsSagas() {
  const GET_ACCOUNTTRANSACTIONS = "GET_ACCOUNTTRANSACTIONS";
  yield takeLatest(GET_ACCOUNTTRANSACTIONS, getAccountTransactionsSaga);
}
